import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ISnackbarService } from '@nibras/core';

@Injectable()
export class SnackbarService implements ISnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  openInfoBar(message: string, action = '', duration = 2000): void {
    this.openBar(message, action, {
      duration,
      politeness: 'off'
    });
  }

  openErrorBar(message: string, action = '', duration = 20000): void {
    this.openBar(message, action, {
      duration,
      panelClass: ['error-snack-bar'],
      politeness: 'assertive'
    });
  }

  private openBar(message: string, action: string, config: MatSnackBarConfig) {
    const snackBarRef = this.snackBar.open(message, action, config);
    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss();
    });
  }
}
